module.exports = __webpack_public_path__ + "static/media/twitter-login-logo.0251d8ee.png";